import React from "react";

function SubtleBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0 bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50">

      <svg
        className="absolute inset-0 w-full h-full"
        viewBox="0 0 1400 900"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >

        {Array.from({ length: 12 }).map((_, i) => {

          const section =
            i < 4
              ? 140 + i * 35
              : i < 8
              ? 380 + (i - 4) * 35
              : 680 + (i - 8) * 35;

          const curve1 = Math.random() * 180 + 40;
          const curve2 = Math.random() * 180 - 90;
          const curve3 = Math.random() * 180 + 20;

          const opacity = 0.08 + Math.random() * 0.12;
          const duration = 16 + Math.random() * 18;
          const delay = -Math.random() * 10;

          const colors = [
            "#22D3EE",
            "#3B82F6",
            "#6366F1",
            "#0EA5E9",
            "#06B6D4",
          ];

          const color = colors[i % colors.length];

          return (
            <path
              key={i}
              d={`
                M0 ${section}
                Q250 ${section - curve1}
                500 ${section + curve2}
                T1000 ${section + curve3}
                T1400 ${section}
              `}
              fill="none"
              stroke={color}
              strokeWidth={1.2 + Math.random() * 1.4}
              strokeOpacity={opacity}
            >
              <animate
                attributeName="d"
                dur={`${duration}s`}
                repeatCount="indefinite"
                begin={`${delay}s`}
                values={`
                  M0 ${section}
                  Q250 ${section - curve1}
                  500 ${section + curve2}
                  T1000 ${section + curve3}
                  T1400 ${section};

                  M0 ${section}
                  Q250 ${section + curve2}
                  500 ${section - curve3}
                  T1000 ${section + curve1}
                  T1400 ${section};

                  M0 ${section}
                  Q250 ${section - curve1}
                  500 ${section + curve2}
                  T1000 ${section + curve3}
                  T1400 ${section}
                `}
              />
            </path>
          );
        })}

      </svg>
    </div>
  );
}

export default SubtleBackground;